import { useState } from "react";
import { groupApi } from "../api/group.service";
import { SingleMoveAttendantPayload } from "../types";

export const useMoveSingleAttendant = () => {
  const [loading, setLoading] = useState<boolean>(false);

  const mutation = async (
    source_group_id: string,
    payload: SingleMoveAttendantPayload
  ) => {
    try {
      setLoading(true);

      const response: any = await groupApi.moveSingleMember(
        source_group_id,
        payload
      );

      return {
        success: true,
        message: response?.data?.message,
      };
    } catch (err: any) {
      console.log("Move single attendant failed:", err);

      return {
        success: false,
        message: err?.response?.data?.message || "Something wrong",
      };
    } finally {
      setLoading(false);
    }
  };

  return {
    mutation,
    loading,
  };
};
